// extracted by mini-css-extract-plugin
export default {"line":"CompanyForm_line__uzrlW"};